import { Type } from '@sinclair/typebox';
// Coarse status, ensure-semantics, no step checkpoints (D14).
export var ProvisioningStatus;
(function (ProvisioningStatus) {
    ProvisioningStatus["PENDING"] = "PENDING";
    ProvisioningStatus["IN_PROGRESS"] = "IN_PROGRESS";
    ProvisioningStatus["READY"] = "READY";
    ProvisioningStatus["FAILED"] = "FAILED";
})(ProvisioningStatus || (ProvisioningStatus = {}));
export const ProjectWorkspaceStatusSchema = Type.Object({
    projectId: Type.String(),
    status: Type.Enum(ProvisioningStatus),
    siteUrl: Type.Union([Type.String(), Type.Null()]),
    attempts: Type.Number(),
    lastError: Type.Union([Type.String(), Type.Null()]),
    startedAt: Type.Union([Type.String(), Type.Null()]), // ISO
    provisionedAt: Type.Union([Type.String(), Type.Null()]),
});
